export enum EmployeeSort {
  FirstName = 1,
  LastName = 2,
  EmploymentStart = 3,
  EarliestEventStart = 4,
}
